import { queryAll, query, fromId } from '../utils/utils.js';

export class SearchPage {


    constructor() {

        this.checkForContactBlocks();

    }

    checkForContactBlocks() {

        queryAll('.search-input-container').forEach((hero) => {

            if (hero.querySelector('.contact-block')) {
                hero.classList.add('contact-block-true');
            } else {
                hero.classList.add('contact-block-false');
            }

        });
    }

}